/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { FirmwareUpgradeService } from '../../shared/services/firmware-upgrade.service';
import { RTIService } from './rti.service';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ModalService } from '@msi/cobalt';

@Injectable({ providedIn: 'root' })
export class RtiFirmwareUpgradeService extends FirmwareUpgradeService {
    public readonly FIRMWARE: { [key: string]: string } = {
        '0.1.14': 'assets/firmware/RTI_UPGRADE_0.1.14.bin',
        '0.1.15': 'assets/firmware/RTI_UPGRADE_0.1.15b.bin',
        // '0.1.16': 'assets/firmware/RTI_UPGRADE_0.1.16.bin'
    };
    constructor(
        public rtiService: RTIService,
        protected http: HttpClient,
        protected store: Store,
        protected modalService: ModalService
    ) {
        super(rtiService, http, store, modalService);
    }
}
